var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3954 2.01172C6.2301 2.01172 2.02246 6.21935 2.02246 11.3847C2.02246 16.55 6.2301 20.7659 11.3954 20.7659C13.6017 20.7659 15.6308 19.9927 17.2345 18.7089L21.1387 22.6111C21.3357 22.7999 21.5989 22.9042 21.8718 22.9014C22.1447 22.8986 22.4056 22.789 22.5988 22.5962C22.7919 22.4033 22.9018 22.1426 22.905 21.8696C22.9081 21.5967 22.8043 21.3334 22.6157 21.1361L18.7115 17.2319C19.9963 15.6258 20.7704 13.5935 20.7704 11.3847C20.7704 6.21935 16.5608 2.01172 11.3954 2.01172ZM11.3954 4.09508C15.4348 4.09508 18.6851 7.34529 18.6851 11.3847C18.6851 15.4241 15.4348 18.6825 11.3954 18.6825C7.35601 18.6825 4.10579 15.4241 4.10579 11.3847C4.10579 7.34529 7.35601 4.09508 11.3954 4.09508Z",
    fill: "#192252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8599afbd91e3cecaf5148e6e7e81c496.svg";
export { ForwardRef as ReactComponent };